module.exports = __webpack_public_path__ + "static/media/money-bill-wave-alt.a7ef0d5a.svg";